
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"7.5","cy":"10.5","r":"1.125"}}),_c('path',{attrs:{"d":"M17.25 11.25a.75.75 0 01-.75-.75h-.75a.75.75 0 010-1.5h2.031a.589.589 0 00.543-.824.584.584 0 00-.323-.317l-2.063-.825a2.083 2.083 0 01-1.312-1.94c0-.559.217-1.084.612-1.479a2.07 2.07 0 011.262-.604V3A.75.75 0 0118 3h.75a.75.75 0 010 1.5h-2.033a.587.587 0 00-.418.174.59.59 0 00.198.967l2.063.825a2.094 2.094 0 011.161 2.722 2.082 2.082 0 01-1.721 1.3v.012a.75.75 0 01-.75.75z"}}),_c('path',{attrs:{"d":"M17.25 13.5c-3.722 0-6.75-3.028-6.75-6.75S13.528 0 17.25 0 24 3.028 24 6.75s-3.028 6.75-6.75 6.75zm0-12C14.355 1.5 12 3.855 12 6.75S14.355 12 17.25 12s5.25-2.355 5.25-5.25-2.355-5.25-5.25-5.25z"}}),_c('path',{attrs:{"d":"M17.25 24a.748.748 0 01-.727-.568l-.51-2.043A9.684 9.684 0 0111.23 22.5a9.758 9.758 0 01-4.733-1.142l-.518 2.074a.752.752 0 01-1.372.204.744.744 0 01-.084-.568l.639-2.557A9.79 9.79 0 012.822 18H.75a.75.75 0 01-.75-.75v-6a.75.75 0 01.75-.75h1.321a8.939 8.939 0 012.697-3.694l.318-2.537c.035-.285.151-.553.336-.774a1.487 1.487 0 011.157-.541c.347 0 .686.123.955.348l1.983 1.653a.75.75 0 01-.96 1.152L6.574 4.454l-.356 2.845a.755.755 0 01-.292.505 7.432 7.432 0 00-2.612 3.675A.747.747 0 012.6 12H1.5v4.5h1.74c.265 0 .513.142.647.37a8.392 8.392 0 007.21 4.131l.141-.001.249.003a8.14 8.14 0 004.475-1.326.752.752 0 01.23-.155 7.76 7.76 0 00.491-.375.841.841 0 01.095-.094c.12-.097.243-.204.375-.326a8.225 8.225 0 002.075-3.307.747.747 0 01.95-.474.75.75 0 01.473.948 6.403 6.403 0 01-.049.138.564.564 0 01-.021.078 8.997 8.997 0 01-2.306 3.619l-.113.107a9.505 9.505 0 01-.817.701l.632 2.531a.75.75 0 01-.727.932z"}})])
          )
        }
      }
    